
import { Collection } from '@/state/Collection';
import { _GAMES, LoadState } from "@/state";
import { Game } from "@/state/Game";

import { GamesRoutes, SprintPlannerRoutes } from '@/repository/resources';
import { LoadGames } from '../../state';
const { GetAllGames, GetGame, CreateGame, UpdateGame, DeleteGame, GetGameLeaderboard, GetGameMomentum, RestoreGame, ForceDeleteGame } = GamesRoutes;
const { UpdateSprintPlanner } = SprintPlannerRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		current: Game.stateDefaults(),
		_all: new Collection({ statePath: 'games.all', autoSortRule: { key: 'created_at', asc: false } }),
		_current: new Game(),
	},
	actions: {

		async index({ commit }, args) {
			try {
				let { page, per_page, with_trashed } = Object.assign({}, args)
				let res = await GetAllGames({ page, per_page, with_trashed });
				commit('SET_GAMES_LIST', res.data);
			}
			catch (error) {
				console.error('Games could not be indexed.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			try {
				if (_GAMES().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllGames({ page: _GAMES().pagination.nextPage() })
				commit('APPEND_MULTIPLE_GAMES_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of actions could not be indexed.', error);
				throw error;
			}
		},

		async show({ }, { game, sprint = null }) {
			try {
				if (game.sprints.length) {
					sprint = sprint ? sprint : game.sprint ? game.sprint.id : null;
				}
				let res = await GetGame({ game: game, sprint: sprint });
				return res.data
			}
			catch (error) {
				console.error('Game could not be shown.', error);
				throw error;
			}
		},

		async loadGame({ commit, state, dispatch }, { game, sprint = null, force = false }) {
			try {
				if (!game) {
					commit('UNLOAD_GAME')
					// Remove from Local Storage
					Game.localStorage.remove()

					LoadState()

					return;
				}

				if (!force && game.id == state.current.id) {
					return true;
				}

				// Set a New Game as Current
				let res = await GetGame({ game, sprint })
				commit('SET_CURRENT_GAME', res.data)

				// Save to Local Storage
				Game.localStorage.set(game.id)

				// TODO: I need to load games that are edited but have no sprints... but this may cause errors elsewhere
				if (sprint) {
					LoadState(res.data)
				} else {
					LoadGames()
				}

				return res;
			}
			catch (error) {
				// Unload game
				commit('UNLOAD_GAME')

				// Reset games list to exclude game
				if (state._all.data.items) {
					let data = state._all.data.items.filter(g => g.id !== game.id);
					commit('SET_GAMES_LIST', data)
				}

				// Remove game from Local Storage
				Game.localStorage.remove()

				return false
			}
		},

		async createOrUpdate({ commit }, { game, sprint = null }) {
			try {
				let res = {}
				if (game.id) {
					res = await UpdateGame({ game, sprint });
					commit('UPDATE_GAME', res.data)
				}
				else {
					res = await CreateGame({ game });
					commit('APPEND_SINGLE_GAME_TO_LIST', res.data)
				}
				return res
			}
			catch (error) {
				console.error('Game could not be created/updated.', error);
				throw error;
			}
		},

		async updateSprintPlanner({ commit }, { data }) {
			try {
				return await UpdateSprintPlanner({ data });
			}
			catch (error) {
				console.error('Sprint planner could not be created/updated.', error);
				throw error;
			}
		},

		async delete({ commit }, { game }) {
			try {
				let res = await DeleteGame({ game });
				if (res.status !== 200) {
					throw 'Problem occurred when deleting game.';
				}
				commit('UPDATE_GAME', res.data) // So that can view in archived
				return true;
			}
			catch (error) {
				console.error('Game could not be deleted.', error);
				throw error;
			}
		},

		async restore({ commit }, { game }) {
			try {
				let res = await RestoreGame({ game });
				if (res.status !== 200) {
					throw 'Problem occurred when restoring game.';
				}
				commit('UPDATE_GAME', res.data) // Remove deleted_at tag
				return true;
			}
			catch (error) {
				console.error('Game could not be restored.', error);
				throw error;
			}
		},

		async forceDelete({ commit }, { game }) {
			try {
				let res = await ForceDeleteGame({ game });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting game.';
				}
				commit('DELETE_GAME', game)
				return true;
			}
			catch (error) {
				console.error('Game could not be deleted.', error);
				throw error;
			}
		},

		async showEmpty({ }) {
			return await Game.defaults()
		},

		async loadLeaderboard({ commit, dispatch }, { game, sprint }) {
			try {
				let res = await GetGameLeaderboard({ game, sprint });
				// if (game) {
				// 	commit('SET_GAME_STANDINGS', res.data)
				// } else {
				// 	commit('LOAD_TENANT_STANDINGS', res.data);
				// }
				return res.data;
			}
			catch (error) {
				console.error('Game Leaderboard could not be indexed.', error);
			}
		},

		async loadMomentum({ commit, dispatch }, { game, sprint }) {
			try {
				let res = await GetGameMomentum({ game, sprint });
				return res.data;
			}
			catch (error) {
				console.error('Game Momentum could not be indexed.', error);
			}
		},

	},
	mutations: {
		SET_GAMES_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_SINGLE_GAME_TO_LIST(state, obj) {
			state._all.items.append(obj).commitToState();
		},
		APPEND_MULTIPLE_GAMES_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		PREPEND_SINGLE_GAME_TO_LIST(state, obj) {
			state._all.items.prepend(obj).commitToState();
		},

		UNLOAD_GAME(state) {
			state.current = state._current.unload()
		},
		SET_CURRENT_GAME(state, obj) {
			state.current = state._current.commit(obj)
		},
		// SET_GAME_STANDINGS(state, standings) {
		// 	state.current = state._current.commitStandingsAndPlayers(standings)
		// },
		// LOAD_TENANT_STANDINGS(state, standings) {
		// 	state.current = state._current.loadTenantStandingsAndPlayers(standings)
		// },
		SET_GAME_SPRINTS(state, sprints) {
			state.current = state._current.commitSprints(sprints)
		},
		UPDATE_GAME(state, obj) {
			state.current = state._current.updateInCollection(obj).commit()
		},
		DELETE_GAME(state, obj) {
			state.current = state._current.removeFromCollection(obj).commit()
		}
	}
}
